import React, { useState, useEffect } from "react";
import { Container, Row, Col, Stack, Badge, Button, Form, ListGroup, ToggleButton } from "react-bootstrap";
import { RequestService } from "../../../../HttpService/RequestService";
import Placeholder from 'react-bootstrap/Placeholder';
import { MdDelete, MdGrid3X3, MdLocationOn, MdTrain, MdAirportShuttle, MdAirplaneTicket, MdAirplanemodeActive, MdOutlineWater, MdDirectionsBoat, MdRailwayAlert, MdAddRoad, MdHouseboat } from "react-icons/md";
import Swal from 'sweetalert2'
import { TODIS_DROPDOWN, TODIS_FORM_FIELD_CHECK } from "../../../../components/Forms";
import { BsGrid, BsCloudSlashFill, BsCheck, BsX, BsCalendarMinusFill, BsPlusLg } from "react-icons/bs";
import { AuxiliaryService } from "../../../../HttpService/AuxiliaryService";
import 'sweetalert2/src/sweetalert2.scss'
import style from "../Requests.module.scss";
import "../../../DataCollection/style.css";
import { MODAL_REQUEST } from "../../../../components/Modals/ModalForm/ModalRequest";
import { EU_MODAL_REQUEST } from "../../../../components/Modals/ModalForm/EuModalRequest";
import { MODAL_UPD_REQUEST } from "../../../../components/Modals/ModalForm/ModalUpdRequest";
import { RWMARKET_MODAL_REQUEST } from "../../../../components/Modals/ModalForm/RwMarketModalRequest";

const SectionRequests = (props) => {

    const [filterS, setFilterS] = useState({ "Sector": [], "Regional Partner": [], "Type": [], "TENT Category": [], "Eu Sector": [], "Regulatory Area": [] })
    const [filter, setFilter] = useState({})
    const [sectionRequest, setSectionRequest] = useState([])
    const [listSectionActive, setListSectionActive] = useState([])
    const [modalForm, setModalForm] = useState(false)
    const [euModalForm, setEuModalForm] = useState(false);
    const [rwMarketMonModalForm, setRwMarketMonModalForm] = useState(false);
    const [modalCrteUpdRq, setModalCrteUpdRq] = useState(false)
    const [type, setType] = useState([])
    const [sectors, setSectors] = useState([])
    const [tentCategory, setTentCategory] = useState([])
    const [regionals, setRegionals] = useState([])
    const [euSectors, setEuSectors] = useState([])
    const [rwMarketMonSectors, setRwMarketMonSectors] = useState([])
    const [euRegulatoryArea, setEuRegulatoryArea] = useState([])
    const [responseS, setResponseS] = useState(false)
    const [responseList, setResponseList] = useState(false)
    const [sectionNotFound, setSectionNotFound] = useState(false)
    const [isEuAcquis, setIsEuAquis] = useState(false)
    const [isRwMarketMon, setIsRwMarketMon] = useState(false)
    const [selectedValidForYear, setSelectedValidForYear] = useState(null)

    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    const getDataSelect = async () => {
        try {
            const auxiliaries = await new AuxiliaryService("auxData/typeform,regionalpartner,typetransport,tentcategory,euacquis,regulatoryarea,rwmarketmon").getAuxiliaries();
            //const auxiliaries1 = await new AuxiliaryService("auxData/All").getAuxiliaries();

            //console.log("Auxiliaries1", auxiliaries1);
            if (auxiliaries) {
                auxiliaries.map(item => {
                    if (item.txtNameTable == "typeform")
                        setType(item.auxtableDetailsDTOList)
                    if (item.txtNameTable == "regionalpartner") {
                        let list = item.auxtableDetailsDTOList.sort((a, b) =>
                            a.txtDescription.localeCompare(b.txtDescription));
                        ;
                        //console.log("list sorted", list);
                        setRegionals(list);
                    }
                    if (item.txtNameTable == "typetransport")
                        setSectors(item.auxtableDetailsDTOList)
                    if (item.txtNameTable == "tentcategory")
                        setTentCategory(item.auxtableDetailsDTOList)
                    if (item.txtNameTable == "regulatoryarea")
                        setEuRegulatoryArea(item.auxtableDetailsDTOList)
                    if (item.txtNameTable == "euacquis")
                        setEuSectors(item.auxtableDetailsDTOList)
                    if (item.txtNameTable == "rwmarketmon")
                        setRwMarketMonSectors(item.auxtableDetailsDTOList)
                })
                setResponseS(true);
            }
        } catch (error) {
            console.log("error listing selects", error);
        }
    }

    function renderTransportTypeTitle(itm) {
        const singularMap = {
            'Roads': 'Road',
            'Railways': 'Railway',
            'Inland waterways': 'Inland Waterway',
            'Airports': 'Airport',
            'Railways Border Crossings': 'Railway Border Crossing',
            'Roads Border crossing': 'Road Border Crossing',
            'Seaports': 'Seaport',
            'Inland waterway ports': 'Inland Waterway Port'
        };

        const singularTransportTypeName = singularMap[itm.transportTypeName] || itm.transportTypeName;

        const isTENTProjects = ['Roads', 'Railways', 'Inland Waterways', 'Seaports', 'Railways Border Crossings', 'Roads Border crossing', 'Inland waterway ports', 'Freight Terminal'].includes(itm.transportTypeName) &&
            itm.projectTypeName === 'TEN-T Projects' &&
            itm.projectTypeName !== 'EU Acquis';

        const isTENTNetworkPerformance = ['Roads', 'Railways', 'Inland Waterways'].includes(itm.transportTypeName) &&
            itm.projectTypeName === 'TEN-T Network performance monitoring';

        const title = isTENTProjects
            ? `${singularTransportTypeName} Project in ${itm.regionalPartnerName}`
            : isTENTNetworkPerformance
                ? `${singularTransportTypeName} Section in ${itm.regionalPartnerName}`
                : `${singularTransportTypeName} in ${itm.regionalPartnerName}`;
        //console.log(itm)

        return (
            <Col lg={isTENTProjects || isTENTNetworkPerformance ? 7 : 12}>
                <h5 className="fw-bold" style={{ fontSize: "18px" }}>{title}</h5>
                <div style={{ fontSize: "15px", color: "#666" }}>
                    <span style={{ fontWeight: "bold" }}>RequestId: </span> <span style={{ fontWeight: "bold" }}>{itm.request_id}</span>
                </div>
            </Col>
        );
    }

    const createUpdateRequest = async () => {
        const listSection = sectionRequestFilteredByYear.filter(item => item.active);
        if (listSection.length > 0) {
            setListSectionActive(listSection)
            setModalCrteUpdRq(true)
        } else {
            Toast.fire({
                icon: 'warning',
                title: "You must select at least one request"
            })
        }
    }

    const getSections = async (filter) => {
        try {
            return await new RequestService("workflow/data").getRequests(filter);
        } catch (error) {
            console.log(error)
        }
    }

    const handleSelectS = (value, e, name, id) => {
        if (name == "Type" && value == 86) {
            //console.log("changing the filters here", name, value)
            setIsEuAquis(true);
            //go through each selection of the EU AQCUIS Module
            //console.log("applied filters is", filterS["Eu Sector"]);
            //reset the fitlers of the EU Acquis
            if (filterS["Type"].length > 0) {
                filterS["Type"].map(itm => { if (itm.id != 86) removeFilterS("Type", "types", itm.id) })
            }
            if (filterS["TENT Category"].length > 0) {
                filterS["TENT Category"].map(itm => removeFilterS("TENT Category", "tentCategories", itm.id))
            }
            if (filterS["Sector"].length > 0) {
                filterS["Sector"].map(itm => removeFilterS("Sector", "sectors", itm.id))
            }

            // filter?.eu_sectors.map((itm) => removeFilterS())


        } else {
            if (name == "Type" && value != 86) {
                //reset the fitlers of the EU Acquis
                setIsEuAquis(false);
                console.log("the value of it is", name, value)
                if (filterS["Type"].length > 0) {
                    filterS["Type"].map(itm => { if (itm.id == 86) removeFilterS("Type", "types", itm.id) })
                }
                if (filterS["Eu Sector"].length > 0) {
                    filterS["Eu Sector"].map(itm => removeFilterS("Eu Sector", "eu_sectors", itm.id))
                }
                if (filterS["Regulatory Area"].length > 0) {
                    filterS["Regulatory Area"].map(itm => removeFilterS("Regulatory Area", "eu_regulatoryAreas", itm.id))
                }
            }

        }
        if (!filterS[name].some(item => item.name == e.target.text)) {
            setFilterS(prevState => {
                const newValue = { ...prevState };
                newValue[name] = [...newValue[name], { id: value, name: e.target.text }]
                return newValue
            })
            setFilter(prevState => {
                const newValue = { ...prevState };
                if (newValue[id] == undefined) {
                    newValue[id] = [value]
                } else {
                    newValue[id].push(value)
                }
                return newValue
            })

        } else {
            Toast.fire({
                icon: 'warning',
                title: "Filter by " + name + " <b>" + e.target.text + "</b> is already applied"
            })
        }
    }

    const removeFilterS = (name, id, value) => {
        setFilterS(prevState => {
            const newValue = { ...prevState };
            newValue[name] = newValue[name].filter(item => item.id != value)
            return newValue
        })
        setFilter(prevState => {
            const newValue = { ...prevState };
            newValue[id] = newValue[id].filter(item => item != value)
            if (newValue[id].length == 0)
                delete newValue[id]
            return newValue
        })
    }

    const removeAllFilterS = () => {
        setFilterS({ "Sector": [], "Regional Partner": [], "Type": [], "TENT Category": [], "Eu Sector": [], "Regulatory Area": [] })
        setFilter({})
        setSelectedValidForYear(null)
    }

    const extractYearsFromValidFor = (validFor) => {
        if (!validFor) return [];
        const yearMatches = String(validFor).match(/\b(19|20)\d{2}\b/g) || [];
        return [...new Set(yearMatches)];
    }

    const validForYears = [...new Set(
        sectionRequest.flatMap((item) => extractYearsFromValidFor(item.validFor))
    )]
        .sort((a, b) => Number(b) - Number(a))
        .map((year) => ({ id: year, name: year }));

    const sectionRequestFilteredByYear = selectedValidForYear
        ? sectionRequest.filter((item) => extractYearsFromValidFor(item.validFor).includes(String(selectedValidForYear)))
        : sectionRequest;

    const handleValidForYearSelect = (value) => {
        setSelectedValidForYear(String(value));
    }

    const removeValidForYearFilter = () => {
        setSelectedValidForYear(null);
    }

    const refreshRequest = () => {
        props.refreshRequests()
    }

    const selectAll = (e) => {
        setSectionRequest((prevItems) =>
            prevItems.map((item) => {
                const isVisibleByYear = selectedValidForYear
                    ? extractYearsFromValidFor(item.validFor).includes(String(selectedValidForYear))
                    : true;

                // Only affect currently visible items (after DATE VALID FOR filtering).
                if (!isVisibleByYear) {
                    return item;
                }

                return { ...item, active: e.target.checked }
            }
            )
        )
    }

    const toggleSelection = (section) => {

        setSectionRequest((prevItems) =>
            prevItems.map((item) => {
                if (item.id === section.id) {
                    return { ...section, active: !item.active };
                }
                return item;
            })
        );
    }

    useEffect(() => {
        (async () => {
            setResponseList(false)
            let resR = await getSections(filter);
            if (resR) {
                setSectionRequest(prevState => {
                    //console.log("data", resR.response);
                    return resR.response.sort(function (x, y) {
                        // return y.data.requestId - x.data.requestId;
                        return y.name - x.name;
                    });
                }); //resR.response
                setResponseList(true);
            } else {
                setSectionNotFound(true)
            }
        })();
    }, [filter]);

    useEffect(() => {
        (async () => {
            await getDataSelect();
        })();
    }, []);

    return (
        <Col sm={6}>
            <Container fluid className="todis-form-wrapper todis-bulkTask p-4" style={{ height: '95%' }}>
                <Row className="todis-form-action-panel pb-1">
                    <Col lg={6} className="ps-3" style={{ alignSelf: "center" }}>
                        <Stack gap={0}>
                            <h5 className="todis-header"><BsCalendarMinusFill className="me-3" />Create Data Collection Request</h5>
                        </Stack>
                    </Col>
                    {props.permissions.some(item => item.id == 2) && <Col lg={6}>
                        <Row className="float-end">
                            <Col lg={12}>
                                <Button variant="outline-primary w-100" className="todis-reset-btn" style={{ margin: "0px", minWidth: "300px" }} onClick={() => setModalForm(true)}><BsPlusLg size={18} className="me-3" />Create New Item to Monitor</Button>
                            </Col>
                        </Row>
                        <Row className="float-end mt-3">
                            <Col lg={12}>
                                <Button variant="outline-primary w-100" className="todis-reset-btn" style={{ margin: "0px", minWidth: "300px" }} onClick={() => setEuModalForm(true)}><BsPlusLg size={18} className="me-3" />Create New EU Acquis</Button>
                            </Col>
                        </Row>
                        <Row className="float-end mt-3">
                            <Col lg={12}>
                                <Button variant="outline-primary w-100" className="todis-reset-btn" style={{ margin: "0px", minWidth: "300px" }} onClick={() => setRwMarketMonModalForm(true)}><BsPlusLg size={18} className="me-3" />Create Railway Market Monitoring</Button>
                            </Col>
                        </Row>
                    </Col>}
                    <Col lg={12}>
                        <Row className="pt-4">
                            <Col lg={3}>
                                <TODIS_DROPDOWN title="DATE VALID FOR" handleSelect={handleValidForYearSelect} response={responseList} items={validForYears} />
                            </Col>
                            <Col lg={3}>
                                <TODIS_DROPDOWN title="REGIONAL PARTNER" handleSelect={(e, evt) => handleSelectS(e, evt, "Regional Partner", "regionalPartnars")} response={responseS} items={regionals} />
                            </Col>
                            <Col lg={3}>
                                <TODIS_DROPDOWN title="MODULE" handleSelect={(e, evt) => handleSelectS(e, evt, "Type", "types")} response={responseS} items={type} />
                            </Col>
                            {/* <Col lg={3}>
                                <TODIS_DROPDOWN title="SECTOR" handleSelect={(e, evt) => handleSelectS(e, evt, "Sector", "sectors")} response={responseS} items={sectors} />
                            </Col>
                            <Col lg={3}>
                                <TODIS_DROPDOWN title="TENT CATEGORY" handleSelect={(e, evt) => handleSelectS(e, evt, "TENT Category", "tentCategories")} response={responseS} items={tentCategory} />
                            </Col> */}
                            {
                                isEuAcquis ?
                                    <>
                                        <Col lg={3}>
                                            <TODIS_DROPDOWN title="EU ACQUIS SECTOR" handleSelect={(e, evt) => handleSelectS(e, evt, "Eu Sector", "eu_sectors")} response={responseS} items={euSectors} />
                                        </Col>
                                        <Col lg={3}>
                                            <TODIS_DROPDOWN title="REGULATORY AREA" handleSelect={(e, evt) => handleSelectS(e, evt, "Regulatory Area", "eu_regulatoryAreas")} response={responseS} items={euRegulatoryArea} />
                                        </Col>
                                    </> :
                                    <>
                                        <Col lg={3}>
                                            <TODIS_DROPDOWN title="SECTOR" handleSelect={(e, evt) => handleSelectS(e, evt, "Sector", "sectors")} response={responseS} items={sectors} />
                                        </Col>
                                        <Col lg={3}>
                                            <TODIS_DROPDOWN title="TENT CATEGORY" handleSelect={(e, evt) => handleSelectS(e, evt, "TENT Category", "tentCategories")} response={responseS} items={tentCategory} />
                                        </Col>
                                    </>

                            }
                        </Row>
                    </Col>
                    <Col lg={12} className="ps-4 pt-4" style={{ maxHeight: "86px", overflowY: "auto" }}>
                        <Row className="float-start">
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6 style={{ fontSize: "0.9rem" }}>
                                    Regional Partner:
                                    {
                                        filterS["Regional Partner"].length != 0 ?
                                            filterS["Regional Partner"].map((item, index) => {
                                                return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("Regional Partner", "regionalPartnars", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                            })
                                            : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Regional Partner</Badge>
                                    }
                                </h6>
                            </Col>
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6 style={{ fontSize: "0.9rem" }}>
                                    Type:
                                    {
                                        filterS["Type"].length != 0 ?
                                            filterS["Type"].map((item, index) => {
                                                return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("Type", "types", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                            })
                                            : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Type</Badge>
                                    }
                                </h6>
                            </Col>
                            {/* <Col lg={2} style={{ width: 'auto' }}>
                                <h6 style={{ fontSize: "0.9rem" }}>
                                    Sector:
                                    {
                                        filterS["Sector"].length != 0 ?
                                            filterS["Sector"].map((item, index) => {
                                                return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("Sector", "sectors", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                            })
                                            : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Sector</Badge>
                                    }
                                </h6>
                            </Col>
                            <Col lg={2} style={{ width: 'auto' }}>
                                <h6 style={{ fontSize: "0.9rem" }}>
                                    TENT Category:
                                    {
                                        filterS["TENT Category"].length != 0 ?
                                            filterS["TENT Category"].map((item, index) => {
                                                return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("TENT Category", "tentCategories", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                            })
                                            : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All TENT Category</Badge>
                                    }
                                </h6>
                            </Col> */}
                            {isEuAcquis ?
                                <><Col lg={2} style={{ width: 'auto' }}>
                                    <h6 style={{ fontSize: "0.9rem" }}>
                                        Eu Acquis Sectors:
                                        {
                                            filterS["Eu Sector"].length != 0 ?
                                                filterS["Eu Sector"].map((item, index) => {
                                                    return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("Eu Sector", "eu_sectors", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                })
                                                : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Eu Acquis Sectors</Badge>
                                        }
                                    </h6>
                                </Col>

                                    <Col lg={2} style={{ width: 'auto' }}>
                                        <h6 style={{ fontSize: "0.9rem" }}>
                                            Regulatory Areas:
                                            {
                                                filterS["Regulatory Area"].length != 0 ?
                                                    filterS["Regulatory Area"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("Regulatory Area", "eu_regulatoryAreas", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Regulatory Areas</Badge>
                                            }
                                        </h6>
                                    </Col></> : <>
                                    <Col lg={2} style={{ width: 'auto' }}>
                                        <h6 style={{ fontSize: "0.9rem" }}>
                                            Sector:
                                            {
                                                filterS["Sector"].length != 0 ?
                                                    filterS["Sector"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("Sector", "sectors", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All Sector</Badge>
                                            }
                                        </h6>
                                    </Col>
                                    <Col lg={2} style={{ width: 'auto' }}>
                                        <h6 style={{ fontSize: "0.9rem" }}>
                                            TENT Category:
                                            {
                                                filterS["TENT Category"].length != 0 ?
                                                    filterS["TENT Category"].map((item, index) => {
                                                        return <Badge className={style.bgFilter} key={index}><span className={style.cursorPointer} onClick={() => removeFilterS("TENT Category", "tentCategories", item.id)}><BsX fontSize={16} color="#3e84b8" /></span> {item.name}</Badge>
                                                    })
                                                    : <Badge className={style.bgFilter}><BsCheck fontSize={16} color="#3e84b8" /> All TENT Category</Badge>
                                            }
                                        </h6>
                                    </Col>
                                </>
                            }

                            {selectedValidForYear &&
                                <Col lg={2} style={{ width: 'auto' }}>
                                    <h6 style={{ fontSize: "0.9rem" }}>
                                        Valid For Year:
                                        <Badge className={style.bgFilter}><span className={style.cursorPointer} onClick={() => removeValidForYearFilter()}><BsX fontSize={16} color="#3e84b8" /></span> {selectedValidForYear}</Badge>
                                    </h6>
                                </Col>
                            }

                            {(filterS["Regional Partner"].length != 0 || filterS["Type"].length != 0 || filterS["Sector"].length != 0 || filterS["TENT Category"].length != 0 || filterS["Regulatory Area"].length != 0 || filterS["Eu Sector"].length != 0 || selectedValidForYear) &&
                                <Col lg={3} style={{ width: 'auto' }}>
                                    <h6 style={{ fontSize: "0.9rem", cursor: "pointer" }}><span onClick={() => removeAllFilterS()}><MdDelete size={18} color="red" className="me-1" />Remove Filter</span></h6>
                                </Col>
                            }
                        </Row>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <Form.Group className="mb-3">
                            <Form.Label
                                style={{
                                    color: '#004494',
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    fontFamily: "sans-serif"
                                }}>RESULTS</Form.Label>
                            {
                                !sectionNotFound && responseList ?
                                    <Container className="todis-form-wrapperR">
                                        <Row className="list-Items">
                                            <Row>
                                                <Col lg={6}>
                                                    <div className="pt-3">
                                                        <span className={style.textCount}>TOTAL: <h5>{sectionRequestFilteredByYear.length}</h5> | SELECTED: <h5>{sectionRequestFilteredByYear.filter(item => item.active).length}</h5></span>
                                                    </div>
                                                </Col>
                                                <Col lg={6} >
                                                    <div className="pt-3">
                                                        <TODIS_FORM_FIELD_CHECK id="selectAll" label="SELECT ALL" selectAll={selectAll} />
                                                    </div>
                                                </Col>
                                            </Row>
                                            <ListGroup className="overflow-auto mt-3" style={{ maxHeight: "420px", flexGrow: "1" }}>
                                                {sectionRequestFilteredByYear && sectionRequestFilteredByYear.map((itm, index) => {
                                                    return (
                                                        <ListGroup.Item
                                                            key={`itemSelect${index}`}
                                                            onClick={() => toggleSelection(itm)}
                                                            active={itm.active}
                                                            style={{ fontSize: "15px" }}
                                                            className={`${style.dataInfo} ${'mt-3'}`}
                                                        >
                                                            <Container>
                                                                <Row>
                                                                    <Col lg={12}>
                                                                        <Row>

                                                                            {
                                                                                !itm.legalAct ? (
                                                                                    renderTransportTypeTitle(itm)
                                                                                ) : (
                                                                                    <Col lg={12}>
                                                                                        <strong className="" style={{ fontSize: "18px" }}>{itm.legalAct}</strong>
                                                                                    </Col>
                                                                                )
                                                                            }
                                                                            {/* {!itm.legalAct ? (
                                                                            (() => {
                                                                                const singularMap = {
                                                                                    'Roads': 'Road',
                                                                                    'Railways': 'Railway',
                                                                                    'Inland waterways': 'Inland Waterway',
                                                                                    'Airports': 'Airport',
                                                                                    'Railways Border Crossings': 'Railway Border Crossing',
                                                                                    'Roads Border crossing': 'Road Border Crossing',
                                                                                    'Seaports': 'Seaport',
                                                                                    'Inland waterway ports': 'Inland Waterway Port'
                                                                                };

                                                                                const singularTransportTypeName = singularMap[itm.transportTypeName] || itm.transportTypeName;

                                                                                return (
                                                                                    ['Roads', 'Railways', 'Inland Waterways'].includes(itm.transportTypeName) &&
                                                                                    itm.projectTypeName === 'TEN-T Projects' &&
                                                                                    itm.projectTypeName !== 'EU Acquis' ? (
                                                                                        <Col lg={7}>
                                                                                            <h5 className="fw-bold" style={{ fontSize: "18px" }}>{singularTransportTypeName} Project in {itm.regionalPartnerName}</h5>
                                                                                        </Col>
                                                                                    ) : (
                                                                                        ['Roads', 'Railways', 'Inland Waterways'].includes(itm.transportTypeName) &&
                                                                                        itm.projectTypeName === 'TEN-T Network performance monitoring' ? (
                                                                                            <Col lg={7}>
                                                                                                <h5 className="fw-bold" style={{ fontSize: "18px" }}>{singularTransportTypeName} Section in {itm.regionalPartnerName}</h5>
                                                                                            </Col>
                                                                                        ) : (
                                                                                            // Para los demás servicios
                                                                                            <Col lg={12}>
                                                                                                <h5 className="fw-bold" style={{ fontSize: "18px" }}>{singularTransportTypeName} in {itm.regionalPartnerName}</h5>
                                                                                            </Col>
                                                                                        )
                                                                                    )
                                                                                );
                                                                            })()
                                                                        ) : (
                                                                            <Col lg={12}>
                                                                                <strong className="" style={{ fontSize: "18px" }}>{itm.legalAct}</strong>
                                                                            </Col>
                                                                        )} */}
                                                                            {/* {!itm.legalAct ?                                   
                                                                            <Col lg={7}>
                                                                                <h5 className="fw-bold" style={{ fontSize: "18px" }}>Section/Project {itm.transportTypeName}  {itm.regionalPartnerName}</h5>
                                                                            </Col>
                                                                            :
                                                                            <Col lg={12}>
                                                                                <strong className="" style={{ fontSize: "18px" }}>{itm.legalAct}</strong>
                                                                            </Col>
                                                                        } */}
                                                                            {!itm.legalAct ?
                                                                                <Col lg={5} style={{ textAlign: "end" }}>
                                                                                    <span style={{ paddingRight: "8px", fontSize: "13px" }}>Valid For <h5 style={{ display: "inline-block", fontSize: "14px" }}>{itm.validFor}</h5></span>
                                                                                </Col>
                                                                                :
                                                                                <Col lg={12} style={{ textAlign: "end" }}>
                                                                                    <span style={{ paddingRight: "8px", fontSize: "13px" }}>Valid For <h5 style={{ display: "inline-block", fontSize: "14px" }}>{itm.validFor}</h5></span>
                                                                                </Col>
                                                                            }
                                                                        </Row>

                                                                        <Row className="selectable-task">
                                                                            <Col sm="0">
                                                                                <ToggleButton
                                                                                    className="mx-1"
                                                                                    type="checkbox"
                                                                                    size="sm"
                                                                                    key={`check${index}`}
                                                                                    checked={itm.active}
                                                                                    value={itm.id}
                                                                                    hidden
                                                                                ></ToggleButton>
                                                                            </Col>
                                                                            <Col lg={1} className="w-auto">
                                                                                <span><MdGrid3X3 size="20" color="#004494" /> {itm.name}</span>
                                                                            </Col>
                                                                            {itm.startNode && itm.endNode && (
                                                                                <>
                                                                                    <Col lg={2} className="w-auto">
                                                                                        <span><MdLocationOn size="20" color="#004494" /><strong>Node 1:</strong> {itm.startNode}</span>
                                                                                    </Col>
                                                                                    <Col lg={2} className="w-auto">
                                                                                        <span><MdLocationOn size="20" color="#004494" /><strong>Node 2:</strong> {itm.endNode}</span>
                                                                                    </Col>
                                                                                </>
                                                                            )}
                                                                            {itm.legalAct && (
                                                                                <>
                                                                                    <Col lg={2} className="w-auto">
                                                                                        <span><strong>Celex Number:</strong> {itm.celexNumber}</span>
                                                                                    </Col>

                                                                                </>
                                                                            )}

                                                                            {/* {(!itm.startNode || !itm.endNode) && (
                                                                                <Col lg={2} className="w-auto">
                                                                                   <span><MdLocationOn size="20" color="#004494" /><strong>Node Name:</strong> {itm.endNode || itm.startNode}</span>
                                                                                </Col>
                                                                            )} */}

                                                                            {/* Meto solo una de las dos colunmas Node name. */}
                                                                            {/* {itm.startNode && <Col lg={2} className="w-auto">
                                                                                <span><MdLocationOn size="20" color="#004494" /><strong>Node 1:</strong> {itm.startNode}</span>
                                                                            </Col>}
                                                                            {itm.endNode && <Col lg={2} className="w-auto">
                                                                                <span><MdLocationOn size="20" color="#004494" /> <strong>Node 2:</strong> {itm.endNode}</span>
                                                                            </Col>
                                                                            } */}
                                                                            {itm.transportTypeName && (
                                                                                <Col lg={2} className="w-auto">
                                                                                    <span>
                                                                                        {itm.transportTypeName === 'Roads' && <MdAirportShuttle size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Railways' && <MdTrain size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Airports' && <MdAirplanemodeActive size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Freight Terminal' && <MdAirplaneTicket size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Inland waterways' && <MdOutlineWater size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Seaports' && <MdDirectionsBoat size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Railways Border Crossings' && <MdRailwayAlert size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Roads Border crossings' && <MdAddRoad size="20" color="#004494" />}
                                                                                        {itm.transportTypeName === 'Inland waterway ports' && <MdHouseboat size="20" color="#004494" />}
                                                                                        {itm.transportTypeName}
                                                                                    </span>
                                                                                </Col>
                                                                            )}
                                                                            <Col lg={2} className="w-auto">
                                                                                <span><BsGrid size="20" color="#004494" /> {itm.projectTypeName}</span>
                                                                            </Col>
                                                                            <Col lg={2} className="w-auto">
                                                                                <span><MdLocationOn size="20" color="#004494" /> {itm.regionalPartnerName}</span>
                                                                            </Col>
                                                                            {!itm.legalAct && <Col lg={2} className="w-auto">
                                                                                {!itm.legalAct && <Col lg={2} className="w-auto">
                                                                                    <span><BsGrid size="20" color="#004494" /> {itm.tentCategoryName}</span>
                                                                                </Col>}
                                                                            </Col>}
                                                                            {itm.euAcquisSector &&
                                                                                <Col lg={2} className="w-auto">
                                                                                    <span><MdTrain size="20" color="#004494" /> {itm.euAcquisSector}</span>
                                                                                </Col>
                                                                            }
                                                                            {itm.regulatoryArea && <Col lg={2} className="w-auto">
                                                                                <span><BsGrid size="20" color="#004494" /> {itm.regulatoryArea}</span>
                                                                            </Col>
                                                                            }
                                                                        </Row>
                                                                    </Col>
                                                                </Row>
                                                            </Container>
                                                        </ListGroup.Item>
                                                    );
                                                })}
                                            </ListGroup>
                                            <div className="todis-action-listForm" style={{ paddingBottom: "20px" }}>
                                                <Button variant="primary" className="bck-btn-primary todis-submit-btn mt-2" onClick={() => createUpdateRequest()} ><BsPlusLg className="me-3" size="18" />CREATE DATA COLLECTION REQUEST</Button>
                                            </div>
                                        </Row>
                                    </Container>
                                    : sectionNotFound ?
                                        <div className="h-100 d-flex justify-content-center align-items-center"> <div style={{ textAlign: "center" }}>
                                            <BsCloudSlashFill fontSize={100} color="#000000" />
                                            <h3 className="">Section Request Not found </h3>
                                        </div></div>
                                        :
                                        // loading sections 
                                        ([...Array(4)].map((request, index) => (<Col lg={12} className={`${style.dataInfo} ${"mt-4"}`} key={index}><Container>
                                            <Row>
                                                <Col lg={12}>
                                                    <Row>
                                                        <Col lg={7} >
                                                            <Placeholder as="h4" animation="glow"><Placeholder xs={5} size="md" /></Placeholder>
                                                        </Col>
                                                        <Col lg={5} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={12} size="sm" /></Placeholder>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col lg={1} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={12} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={2} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={12} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={3} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={12} size="sm" /></Placeholder>
                                                        </Col>
                                                        <Col lg={2} >
                                                            <Placeholder as="h6" animation="glow"><Placeholder xs={12} size="sm" /></Placeholder>
                                                        </Col>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Container></Col>)))
                            }
                        </Form.Group>
                    </Col>
                </Row>
                {
                    modalForm &&
                    <MODAL_REQUEST show={modalForm} onHide={() => setModalForm(false)} refreshRequest={() => refreshRequest()} />
                }
                {
                    euModalForm &&
                    <EU_MODAL_REQUEST show={euModalForm} onHide={() => setEuModalForm(false)} refreshRequest={() => refreshRequest()} />
                }
                {
                    rwMarketMonModalForm &&
                    <RWMARKET_MODAL_REQUEST show={rwMarketMonModalForm} onHide={() => setRwMarketMonModalForm(false)} refreshRequest={() => refreshRequest()} />
                }
                {
                    modalCrteUpdRq &&
                    <MODAL_UPD_REQUEST show={modalCrteUpdRq} onHide={() => setModalCrteUpdRq(false)} listSectionActive={listSectionActive} pushRequest={() => refreshRequest()} />
                }
            </Container>
        </Col>
    );
}

export default SectionRequests;